module.exports = __webpack_public_path__ + "img/languageScore1.d4a51340.png";